// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_ZIM","cls2":"HeroWorkCardHeader-cls2_ZrN HeroWorkCardHeader-cls1_ZIM"};